<div *ngIf="!sended && currentUser" class="container-fluid container-md">
  <div class="row page">
    <div class="col-lg-5 col-md-9 mx-auto col-12">
      <div class="row">
        <div class="col-5 mx-auto mb-1">
          <img src="assets/images/logo/nepta.svg" alt="logo-nepta" />
        </div>
      </div>
      <div class="card">
        <div class="card-body row">
          <div class="mt-2 col-12">
            <h4 class="mb-1">
              {{ "HELLO" | translate }} <strong>{{ currentUser.firstname }},</strong><span> 👋</span>
            </h4>
          </div>
          <div class="col-12">
            <p class="font-medium-2">{{ "LANDING.HEADER_TITLE" | translate }}</p>
          </div>
          <div class="col-12 mb-3">
            <img class="img-fluid" src="assets/images/illustration/sign-contract.svg" alt="Illustration-sign-contract" />
          </div>
          <div class="col-6 mb-1">
            <button (click)="download()" class="btn btn-primary">{{ "INSERT.DOWNLOAD_CONTRACT" | translate }}</button>
          </div>
          <div class="col-6 mb-1 text-right">
            <button (click)="file.click()" type="button" class="btn btn-primary" rippleEffect>{{ "INSERT.UPLOAD_CONTRACT" | translate }}</button>
            <input type="file" #file id="documents-upload" hidden accept="application/pdf, image/jpg, image/jpeg" (change)="handlerChangeFileInput($event, 'signed_contract')" />
          </div>
        </div>
      </div>
      <div class="mx-auto mb-075">
        <a class="mr-1" target="_blank" href="https://www.facebook.com/neptasrl/">
          <i [size]="'18'" [data-feather]="'facebook'"></i>
        </a>
        <a class="mr-1" target="_blank" href="https://it.linkedin.com/company/nepta">
          <i [size]="'18'" [data-feather]="'linkedin'"></i>
        </a>
        <a class="mr-1" target="_blank" href="https://www.instagram.com/nepta_soluzioni/">
          <i [size]="'18'" [data-feather]="'instagram'"></i>
        </a>
      </div>
    </div>
  </div>
</div>
<div *ngIf="sended" id="thank-you">
  <div>
    <h2>{{ "THANKYOU_FOR_CONTRACT_SIGNED" | translate }}</h2>
    <p>
      {{ "WE_WILL_WRITE_TO_YOU_1" | translate }} <strong>{{ "WE_WILL_WRITE_TO_YOU_2" | translate }}</strong>
    </p>
  </div>
</div>
